import React, { useState } from "react";
import { Tabs, Tab, Box, Button, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Page from "./products/index";
import { useCart } from "../CartContext";
import AddIcon from "@mui/icons-material/Add";
import Swal from "sweetalert2";

const MultiTabPage = () => {
  const { cart, dispatch } = useCart();
  const initialCart = JSON.parse(localStorage.getItem("cart")) || [];
  const [activeTab, setActiveTab] = useState(0);
  const [tabs, setTabs] = useState(() => {
    if (Object.keys(initialCart).length === 0) {
      const newId = 1;
      return [{ id: newId, label: `แท็บ ${newId}`, data: [] }]
    } else {
      if (initialCart && typeof initialCart === "object") {
        return Object.keys(initialCart).map((key, index) => ({
          id: index + 1,
          label: `แท็บ ${index + 1}`,
          data: initialCart[key],
        }));
      }
    }
  });
  const handleAddTab = () => {
    const newId = tabs.length + 1;
    setTabs([...tabs, { id: newId, label: `แท็บ ${newId}`, data: [] }]);
    setActiveTab(tabs.length);
  };

  const handleRemoveTab = (index) => {
    Swal.fire({
      customClass: {
        container: "my-swal",
      },
      title: "ยืนยันที่จะปิดแท็บนี้?",
      text: "คุณจะไม่สามารถย้อนกลับสิ่งนี้ได้!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "ยืนยัน",
      cancelButtonText: "ยกเลิก",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        const newTabs = tabs.filter((_, i) => i !== index);
        let tabId = index + 1;
        dispatch({ type: "CLEAR_CART", payload: { tabId } });
        setTabs(newTabs);
        setActiveTab((prev) => (prev > 0 ? prev - 1 : 0));
      }
    });
  };
  const handleUpdateTabData = (index, newData) => {
    setTabs((prevTabs) => {
      const updatedTabs = [...prevTabs];
      updatedTabs[index].data = newData;
      return updatedTabs;
    });
  };
  return (
    <Box>
      <Tabs
        value={activeTab}
        onChange={(_, newValue) => setActiveTab(newValue)}
        sx={{ marginLeft: "60px" }}
      >
        {tabs.map((tab, index) => (
          <Tab
            key={tab.id}
            label={
              <Box display="flex" alignItems="center">
                {tab.label}
                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleRemoveTab(index);
                  }}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Box>
            }
          />
        ))}
        <Button onClick={handleAddTab}>
          <AddIcon />
          เพิ่มแท็บ
        </Button>
      </Tabs>

      <Box sx={{ p: 2 }}>
        {tabs.map(
          (tab, index) =>
            activeTab === index && (
              <Page
                tabId={tab.id}
                tabData={tab.data}
                updateTabData={(newData) => handleUpdateTabData(index, newData)}
              />
            )
        )}
      </Box>
    </Box>
  );
};

export default MultiTabPage;
